import { c as _c } from "react/compiler-runtime";
// SWEEPSTAKES (DEV-10675). The entries strip under a product tile and on the
// product page.
import { barlowCondensed } from "@local/ui/src/utils/fonts";
import { cn } from "@local/utils/src/cn";
import { entriesBadgeCopy, entriesFor, isSweepstakesActive, type SweepstakesState } from "../../lib/const/sweepstakes";
interface EntriesBadgeProps {
  market: string;
  /** Price the shopper pays, in minor currency units. */
  priceInMinorUnits: number;
  /** Campaign state, resolved on the server. */
  scheduled: SweepstakesState;
  className?: string;
}
export const EntriesBadge = t0 => {
  const $ = _c(11);
  const {
    market,
    priceInMinorUnits,
    scheduled,
    className
  } = t0;
  if (!isSweepstakesActive(market, scheduled)) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== priceInMinorUnits || $[2] !== scheduled) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const entries = entriesFor(priceInMinorUnits, scheduled);
      if (entries === null) {
        t3 = null;
        break bb0;
      }
      if ($[6] !== className) {
        t1 = cn(barlowCondensed.className, "bg-amber-400 py-1.5 text-center text-sm font-semibold tracking-wide text-black uppercase", className);
        $[6] = className;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      t2 = entriesBadgeCopy(entries);
    }
    $[0] = className;
    $[1] = priceInMinorUnits;
    $[2] = scheduled;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};